import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AllDirectionList } from 'widgets/excursions/all-direction-list'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const PopularDirection = () => {
  const { t } = useTranslation()

  return (
    <div className={clsx(s.container, 'container')}>
      <div className={s.header}>
        <HeaderGoBack
          title={t('excursions.popular_title')}
          buttonWhite
        />
      </div>

      <AllDirectionList />
    </div>
  )
}

export default PopularDirection
